import { render, staticRenderFns } from "./MobileOrder.vue?vue&type=template&id=1ae1562c"
import script from "./MobileOrder.vue?vue&type=script&lang=js"
export * from "./MobileOrder.vue?vue&type=script&lang=js"
import style0 from "./MobileOrder.vue?vue&type=style&index=0&id=1ae1562c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports